// extracted by mini-css-extract-plugin
export default {"wrapper__item":"Switcher_wrapper__item__MgeDr","switcher":"Switcher_switcher__0NEyx","switcher__input":"Switcher_switcher__input__Sz96u","hint":"Switcher_hint__LG14U"};